import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class UsersService {
  constructor(private http: HttpClient) {}

  public fetchUsers(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/users`
    return this.http.post(url, params)
  }
  public fetchUser(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/user/${id}`
    return this.http.get(url, {})
  }

  public deleteUser(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/user/${id}`
    return this.http.delete(url)
  }

  public fetchRoles(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/roles`
    return this.http.get(url, params)
  }

  public createUser(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/user`
    return this.http.post(url, params)
  }

  public updateUser(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/user/${id}`
    return this.http.put(url, params)
  }

  public updateUserPassword(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/user/${id}/password`
    return this.http.post(url, params)
  }
}
